module.exports = __webpack_public_path__ + "static/trelleborg-5c3ebe4ebc3507883bc6fbd7da885d73.png";